import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/icon/ic_pass@2x.png'
import _imports_1 from '../../assets/icon/ic_notpass@2x.png'
import _imports_2 from '../../assets/icon/ic_shenhe@2x.png'


const _withScopeId = n => (_pushScopeId("data-v-30373e8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "desc" }
const _hoisted_2 = { class: "desc_info" }
const _hoisted_3 = { class: "desc_info_title" }
const _hoisted_4 = {
  key: 0,
  class: "yellow"
}
const _hoisted_5 = {
  key: 1,
  class: "green"
}
const _hoisted_6 = {
  key: 2,
  class: "red"
}
const _hoisted_7 = {
  key: 3,
  class: "red"
}
const _hoisted_8 = { class: "desc_info_company" }
const _hoisted_9 = { class: "desc_info_box" }
const _hoisted_10 = { class: "desc_info_box_item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "申请编号：", -1))
const _hoisted_12 = { class: "desc_info_box_item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "申请日期：", -1))
const _hoisted_14 = { class: "desc_info_box_item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "申请类型：", -1))
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { key: 2 }
const _hoisted_19 = { key: 3 }
const _hoisted_20 = { class: "desc_info_box_item" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "返修工序：", -1))
const _hoisted_22 = { class: "desc_info_box_item" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "不良原因：", -1))
const _hoisted_24 = { class: "desc_info_box_item" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "申请人：", -1))
const _hoisted_26 = { class: "desc_qd" }
const _hoisted_27 = { class: "desc_qd_header" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc_qd_header_x" }, null, -1))
const _hoisted_29 = { class: "desc_qd_info_item" }
const _hoisted_30 = { class: "black" }
const _hoisted_31 = { class: "black" }
const _hoisted_32 = { class: "desc_qd_info_item" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "物料信息：", -1))
const _hoisted_34 = { class: "desc_qd_info_item" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "批次号：", -1))
const _hoisted_36 = { class: "desc_qd_info_item" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "生产工序：", -1))
const _hoisted_38 = {
  key: 1,
  class: "desc_qd_not"
}
const _hoisted_39 = { class: "desc_process" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc_process_title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "desc_process_title_x" }),
  /*#__PURE__*/_createElementVNode("span", null, "流程")
], -1))
const _hoisted_41 = {
  key: 0,
  class: "desc_process_content"
}
const _hoisted_42 = { class: "item_left" }
const _hoisted_43 = {
  key: 0,
  class: "item_x"
}
const _hoisted_44 = { class: "item_left_img" }
const _hoisted_45 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_46 = {
  key: 1,
  src: _imports_1,
  alt: ""
}
const _hoisted_47 = {
  key: 2,
  src: _imports_2,
  alt: ""
}
const _hoisted_48 = { class: "item_left_text" }
const _hoisted_49 = { class: "item_right" }
const _hoisted_50 = {
  key: 1,
  class: "notfound"
}

import { getsqdInfo } from '@/apis/WorkOrderAPI'
    import { useRoute } from "vue-router"
    import { useStore } from "vuex"
    import { ref, onMounted } from 'vue'

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const route = useRoute()

    const store = useStore()

    let info = ref<object>({})

    const getsqdInfos = () => {
        getsqdInfo(route.query.id)
            .then(res => {
                if (res.code === 200) {
                    info.value = res.data
                }
            })
    }

    onMounted(() => {
        getsqdInfos()
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, _toDisplayString(_unref(info).title), 1),
        (_unref(info).status === 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, "待审核"))
          : (_unref(info).status === 1)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, "审批通过"))
            : (_unref(info).status === 2)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, "审批未通过"))
              : (_unref(info).status === 3)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, "审批终止"))
                : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(store).state.userInfo.rootDepartment.name), 1),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("span", null, _toDisplayString(_unref(info).code), 1)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("span", null, _toDisplayString(_unref(info).createTime), 1)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          (_unref(info).type === 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_16, "不良返工"))
            : _createCommentVNode("", true),
          (_unref(info).type === 1)
            ? (_openBlock(), _createElementBlock("span", _hoisted_17, "客退"))
            : _createCommentVNode("", true),
          (_unref(info).type === 2)
            ? (_openBlock(), _createElementBlock("span", _hoisted_18, "客返"))
            : _createCommentVNode("", true),
          (_unref(info).type === 3)
            ? (_openBlock(), _createElementBlock("span", _hoisted_19, "报废申请"))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _createElementVNode("span", null, _toDisplayString(_unref(info).backProcedureName), 1)
        ]),
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          _createElementVNode("span", null, _toDisplayString(_unref(info).content), 1)
        ]),
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _createElementVNode("span", null, _toDisplayString(_unref(info).createUserName) + " / " + _toDisplayString(_unref(info).departmentName), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("div", _hoisted_27, [
        _hoisted_28,
        _createElementVNode("span", null, "返工工装清单(" + _toDisplayString(_unref(info).detailList ? _unref(info).detailList.length : '0') + ")", 1)
      ]),
      (_unref(info) && _unref(info).detailList && _unref(info).detailList.length > 0)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(info).detailList, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "desc_qd_info",
              key: index
            }, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("span", _hoisted_30, "工装信息：" + _toDisplayString(item.applianceCode) + " / ", 1),
                _createElementVNode("span", _hoisted_31, _toDisplayString(item.num) + _toDisplayString(item.unitName), 1)
              ]),
              _createElementVNode("div", _hoisted_32, [
                _hoisted_33,
                _createElementVNode("span", null, _toDisplayString(item.materialName) + " | " + _toDisplayString(item.materialCode), 1)
              ]),
              _createElementVNode("div", _hoisted_34, [
                _hoisted_35,
                _createElementVNode("span", null, _toDisplayString(item.batch), 1)
              ]),
              _createElementVNode("div", _hoisted_36, [
                _hoisted_37,
                _createElementVNode("span", null, _toDisplayString(item.procedureName), 1)
              ])
            ]))
          }), 128))
        : (_openBlock(), _createElementBlock("div", _hoisted_38, "暂无工装"))
    ]),
    _createElementVNode("div", _hoisted_39, [
      _hoisted_40,
      (_unref(info).recordList && _unref(info).recordList.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(info).recordList, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item",
                key: index
              }, [
                _createElementVNode("div", _hoisted_42, [
                  (_unref(info).recordList.length - 1 !== index)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_43))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("p", null, _toDisplayString(item.userModel ? item.userModel.name.substr(0, 1) : '-'), 1),
                    (item.operationResult === 'AGREE')
                      ? (_openBlock(), _createElementBlock("img", _hoisted_45))
                      : (item.operationResult === 'REFUSE')
                        ? (_openBlock(), _createElementBlock("img", _hoisted_46))
                        : (item.operationResult === 'NONE')
                          ? (_openBlock(), _createElementBlock("img", _hoisted_47))
                          : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("span", null, _toDisplayString(index === 0 ? '发起申请' : '审批人'), 1),
                    _createElementVNode("span", null, _toDisplayString(item.userModel ? item.userModel.name : '-'), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_49, _toDisplayString(item.date), 1)
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_50, "暂无数据"))
    ])
  ]))
}
}

})